import LDClient from 'launchdarkly-js-client-sdk';

let ldClient = null;

function initialize(clientSideId, user) {
  ldClient = LDClient.initialize(clientSideId, user);
}

function onReady(callback) {
  if (ldClient) {
    ldClient.on('ready', callback);
  }
}

function getFeatureFlag(flagKey, defaultValue) {
  if (ldClient) {
    return ldClient.variation(flagKey, defaultValue);
  }
  return defaultValue;
}

export default {
  initialize,
  onReady,
  getFeatureFlag
}; 